import React from "react";
import Loadable from "react-loadable";
import { Switch, Route } from "react-router-dom";
import {NotFound} from "~/views/Errors";
import LoadingSpinner from "~/components/LoadingSpinner";

const AliasEditorView = Loadable({
    loader: () => import("~/views/admin/aliasing"),
    loading: LoadingSpinner
});

export default ({ match }) => (
    <Switch>
        <Route path={`${match.url}/new`} component={AliasEditorView} />
        <Route path={`${match.url}/:id`} component={AliasEditorView} />
        <Route component={NotFound} />
    </Switch>
);